function startTracking(name) {
  performance.mark(`${name}_start`);
}
function endTracking(name) {
  var _a, _b;
  const startMark = `${name}_start`;
  if (((_a = window.BOOMR) == null ? void 0 : _a.sendAll) && performance.getEntriesByName(startMark).length > 0) {
    performance.measure(name, startMark);
    window.BOOMR.sendAll({
      vars: { "cdim.Interaction": `AccPortal_${name}` },
      timers: {
        Interaction: ((_b = performance.getEntriesByName(name).slice(-1)[0]) == null ? void 0 : _b.duration) || 0
      }
    });
  }
}
export {
  endTracking,
  startTracking
};
//# sourceMappingURL=track-performance.js.map
